export default defineNuxtPlugin(() => {
  if (process.server) {
    return false // Only run on client side
  }

  const router = useRouter()
  if (!window.vueRouter) window.vueRouter = router
})
